import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import { getSoloProposalUrl, postSyncSolo } from "../../lib/api/proposal-api";
import { RootState } from "../../rootReducer";
import { EnerfloProposalData } from "../../types";

export const fetchSoloProposalUrl = createAsyncThunk<string, undefined, { state: RootState }>(
  "data/fetchSoloProposalUrl",
  async (_, thunkAPI) => {
    const proposalId = thunkAPI.getState().proposal.reportHash;

    try {
      const response = await getSoloProposalUrl(proposalId);
      return response.data;
    } catch (e) {
      let error = e as AxiosError<any>;
      return thunkAPI.rejectWithValue({ errors: error.response?.data ?? {} });
    }
  }
);

export const syncSoloProposal = createAsyncThunk<EnerfloProposalData, undefined, { state: RootState }>(
  "data/syncSoloProposal",
  async (_, thunkAPI) => {
    const proposalId = thunkAPI.getState().proposal.reportHash;

    try {
      const response = await postSyncSolo(proposalId);
      return response.data;
    } catch (e) {
      let error = e as AxiosError<any>;
      return thunkAPI.rejectWithValue({ errors: error.response?.data ?? {} });
    }
  }
);
